export default "__VITE_ASSET__CeShZRkY__"